import React from 'react'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {Button} from '@mui/material'
import { useTranslation } from "react-i18next";

export const ExportToExcel = ({ apiData, colWidths, fileName }) => {
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const { i18n, t } = useTranslation();
  // const colWidths = [{ wch: 12 }];
  

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData, {skipHeader: true});
    if(colWidths) ws['!cols'] = colWidths;
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button variant="contained" size="large" onClick={(e) => exportToCSV(apiData, fileName)}>{t('export.buttonExport')}</Button>
  );
};


